module.exports = __webpack_public_path__ + "img/Group_39932@2x.036d8d48.png";